export default __webpack_public_path__ + "static/media/img01.e079edd0.png";